import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-add-row-dialog',
  templateUrl: './add-row-dialog.component.html',
  styleUrls: ['./add-row-dialog.component.scss']
})
export class AddRowDialogComponent implements OnInit {
  numberOfColumns: number;
  constructor(public dialogRef: MatDialogRef<AddRowDialogComponent>) {
    this.numberOfColumns = 0;
  }

  ngOnInit(): void {
  }

  close(columns?: number): void {
    this.dialogRef.close(columns);
  }

  createRow(): void {
    this.close(this.numberOfColumns);
  }
}
